import { GetCustomersResponseSchema } from '@weft/api-definition';
import type { PaginationInput } from '@weft/types';
import { ALL_ITEMS_PAGE_SIZE_CODE } from '@weft/types';
import { validateNotEmptyObject } from '@weft/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useAllCustomers() {
  const allCustomersQuery = useCustomers({ page: 0, pageSize: ALL_ITEMS_PAGE_SIZE_CODE });

  return allCustomersQuery;
}

function useCustomers({ page, pageSize }: PaginationInput) {
  const customersQuery = useQuery(
    ['customers', page, pageSize],
    async () => {
      const privateApi = getPrivateApi();
      const getCustomersResponse = await privateApi.getCustomers({ page, pageSize });

      return GetCustomersResponseSchema.parse(getCustomersResponse);
    },
    { suspense: true },
  );
  validateNotEmptyObject(customersQuery.data, 'Customers');

  return customersQuery;
}